import { invokeLambda } from "../../../hooks/util";
import { LinkedInProfilePicV2 } from "../types/profile-pic-v2";

export async function getLinkedInProfileImage(
  url: string
): Promise<LinkedInProfilePicV2> {
  const id = url.match(/linkedin\.com\/in\/([^/?]+)/)?.[1];
  if (!id) {
    throw new Error("Invalid LinkedIn URL format");
  }
  const pfp: LinkedInProfilePicV2 = await invokeLambda(
    `PersonsApiHandler-staging`,
    {
      httpMethod: "GET",
      path: `/persons/images`,
      queryStringParameters: {
        ids: id,
      },
    }
  )
    .then(async (response) => {
      if (response.statusCode !== 200) {
        const error = new Error("Failed to get profile picture");
        error.name = response.statusCode.toString();
        throw error;
      }

      const profilePics = JSON.parse(response.body) as LinkedInProfilePicV2[];

      console.log(`Done fetching profile ${url}`, profilePics);
      return profilePics[0];
      // return await response.body.json().then((json) => {
      //   const profilePic = json as Response;
      //   return profilePic;
      // });
    })
    .catch((err) => {
      console.error(err);
      throw err;
    });
  return pfp;
}

// export async function getLinkedInProfileImage(
//   url: string
// ): Promise<LinkedInProfilePicV2> {
//   const id = url.match(/linkedin\.com\/in\/([^/?]+)/)?.[1];

//   const pfp: LinkedInProfilePicV2 = await get({
//     apiName: "theCyberScoreRestApi",
//     path: "/persons",
//     options: {
//       queryParams: { ids: id ?? "" },
//     },
//   })
//     .response.then(async (response) => {
//       const data = (await response.body.json()) as LinkedInProfilePicV2[];
//       return data[0];
//     })
//     .catch((err) => {
//       console.error(err);
//       throw err;
//     });
//   return pfp;
// }
